import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screenshot-one',
  templateUrl: './screenshot-one.component.html',
  styleUrls: ['./screenshot-one.component.css']
})
export class ScreenshotOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
